import React from 'react';
import T from 'prop-types';
// components
import { FormattedMessage } from 'react-intl';
import Line from 'components/Line';
import { InfoRow } from 'components/Barnsheets/BarnsheetsDailyCheckup/Section';
// utils
import classnames from 'classnames/bind';
// styles
import styles from './ReportedSegment.module.scss';

const cn = classnames.bind(styles);

const rowProps = { label: T.node.isRequired, value: T.node };
const headerProps = { children: T.node.isRequired };

// Checkup form
const SegmentHeader = ({ children }) => <div className={cn('line', 'sub-header')}>{children}</div>;
const SegmentRow = ({ label, value }) => (
  <div className={cn('line')}>
    <span>{label}</span>
    <span className={cn('semibold', 'value')}>{value}</span>
  </div>
);

// FarmFeed collapse
const CollapseHeader = ({ children }) => <Line almostWhite bolded>{children}</Line>;
const CollapseRow = ({ label, value }) => <Line boldedValue label={label} value={value} />;

// Barnsheets section
const BarnsheetsHeader = ({ children }) => <InfoRow gray leftSemibold onlyLeft leftValue={children} />;
const BarnsheetsRow = ({ label, value }) => <InfoRow rightSemibold leftValue={label} rightValue={value} />;

SegmentHeader.propTypes = headerProps;
CollapseHeader.propTypes = headerProps;
BarnsheetsHeader.propTypes = headerProps;
SegmentRow.propTypes = rowProps;
CollapseRow.propTypes = rowProps;
BarnsheetsRow.propTypes = rowProps;

const variants = {
  segment: { Header: SegmentHeader, Row: SegmentRow },
  collapse: { Header: CollapseHeader, Row: CollapseRow },
  barnsheets: { Header: BarnsheetsHeader, Row: BarnsheetsRow },
};

// Per-sensor BarnTools rows under a section's barn-level figures.
// The variant matches the row primitive of the place it sits in.
const BarnToolsSensorLines = ({ lines, variant }) => {
  if (!lines.length) return null;
  const { Header, Row } = variants[variant];

  return (
    <>
      <Header>
        <FormattedMessage id="general.barnToolsBySensor" />
      </Header>
      {lines.map(({ key, label, value }) => <Row key={key} label={label} value={value} />)}
    </>
  );
};

BarnToolsSensorLines.propTypes = {
  lines: T.arrayOf(T.shape({
    key: T.string.isRequired,
    label: T.node.isRequired,
    value: T.node,
  })).isRequired,
  variant: T.oneOf(Object.keys(variants)),
};

BarnToolsSensorLines.defaultProps = {
  variant: 'segment',
};

export default BarnToolsSensorLines;
